import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Brand } from '../../../business-entities/brand.model';
import { RentalCarService } from '../../../business-services/rental-car.service';
import { ImageService } from '../../../services/image.service';
import { CurrentLanguage } from '../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { UserDataService } from '../../../../../../../src/app/DataServices/user-data.service';
import * as Enums from '../../../../../../Autofacets-Core/src/app/utils/enums';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model'
import { Constant } from '../../../../../../Autofacets-Core/src/app/utils/constant';
import { CheckListBusinessService } from '../../../business-services/check-list.service';

import { PreferenceModel, EditPreference } from '../../../business-entities/preferences-model';
import { PreferenceBusinessService } from '../../../business-services/preference.service';
import { BaseService } from '../../../../../../Autofacets-Core/src/app/services/base.service';

@Component({
  selector: 'app-edit-preferences',
  templateUrl: './edit-preferences.component.html',
  styleUrls: ['./edit-preferences.component.css']
})
export class EditPreferencesComponent implements OnInit {

  AnswerList = Array(1);
  editPreference = false;
  editPreferenceForm: FormGroup;
  brandList: Brand[] = [];
  brand: Brand[];
  id: number;
  language: string;
  image: string | ArrayBuffer;
  PreferenceModel: PreferenceModel;
  editedPreference: EditPreference = {
    brandId: null,
    question: "",
    description: "",
    updatedBy: "",
    imageBinaryData: "",
    mimeType: "",
    image: "",
    preferenceImage: "",
    answerInputs: ""
  };
  isMaxAnswer: boolean = false
  answers: string
  imageBaseData: string | ArrayBuffer = null;
  allLanguage: any[];
  vehicleTypes: VehicleType[] = [];
  multipleAnsweroptions: FormArray
  constructor(
    private formBuilder: FormBuilder,
    private getAllBrandData: RentalCarService,
    private preferenceService: PreferenceBusinessService,
    private spinner: NgxSpinnerService,
    private baseService: BaseService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cdr: ChangeDetectorRef,
    private activeModal: NgbActiveModal,
    private userService: UserDataService,
    private imageService: ImageService,
    private checkListService: CheckListBusinessService
  ) { }

  ngOnInit(): void {
    this.allLanguage = this.currentLanguageService.LanguageList;
    this.editPreferenceForm = this.formBuilder.group({
      questionDescription: new FormArray([]),
      brand: [null, [Validators.required]],
      question: new FormArray([]),
      //answerInputs: ['', [Validators.required]],
      answers: this.formBuilder.array([
        new FormControl(''),
        new FormControl('')
      ]),
      image: [''],
      isActive: ['']
    });
    this.getBrandData();
    this.getLanguage();
    this.GetAllVehicleTypes();
    this.editPreferenceForm.controls.brand.disable();
  }

  get answerInputsControls() {
    return (<FormArray>this.editPreferenceForm.get('answers')).controls;
  }
  addPreferenceAnswer() {
    if ((<FormArray>this.editPreferenceForm.get("answers")).length < 2) {
      const control = new FormControl('', Validators.required);
      (<FormArray>this.editPreferenceForm.get('answers')).push(control);
      this.answers = this.editPreferenceForm.get('answers').value.toString()
    }
    else {
      this.isMaxAnswer = true;
    }
  }

  removeAnswer(index) {
    (<FormArray>this.editPreferenceForm.get('answers')).removeAt(index);
    this.isMaxAnswer = false;
  }

  get t() { return this.cpf.questionDescription as FormArray; }
  get c() { return this.cpf.question as FormArray; }

  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
      for (let i = this.t.length; i < number; i++) {
        this.t.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          description: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.t.length; i >= number; i--) {
        this.t.removeAt(i);
      }
    }
    if (this.c.length < number) {
      for (let i = this.c.length; i < number; i++) {
        this.c.push(this.formBuilder.group({
          languageId: ['', Validators.required],
          name: ['', Validators.required],
        }));
      }
    } else {
      for (let i = this.c.length; i >= number; i--) {
        this.c.removeAt(i);
      }
    }
  }

  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if (localStorage.getItem("Theme") == Constant.BnhInterface) {
        this.vehicleTypes = data.responseObject;
      }
      else {
        this.vehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  async getBrandData() {
    this.id = this.preferenceService.PreferenceId
    await this.GetAllBrand();
    this.currentLanguageService.currentLanguage.subscribe(x => {
      this.language = x
      this.getPreference(this.id);
    });
  }
  get cpf() {
    return this.editPreferenceForm.controls;
  }

  async GetAllBrand() {
    await this.getAllBrandData.GetAllBrand().then(data => {
      this.brand = data.responseObject;
      for (let value of this.brand) {
        this.brandList.push(value)
      }
    })
  }

  onChangeFileUpload(files: FileList) {
    const me = this;
    const file = files[0];
    this.editedPreference.mimeType = files[0].type;
    this.editedPreference.image = files[0].name;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_readerEvent) => {
      this.PreferenceModel.preferenceDetails.imagePath = "";
      me.imageBaseData = reader.result;
      this.editedPreference.imageBinaryData = reader.result.toString().replace('data:' + this.editedPreference.mimeType + ';base64,', '');
      this.editedPreference.preferenceImage = me.imageBaseData;
      this.image = me.imageBaseData;
    };
    reader.onerror = function (_error) {
      // This is intentional
    };

  }


  async getPreference(id: number) {
    this.spinner.show();
    await this.preferenceService.getPreferenceById(id).then(result => {
      if (result) {
        this.PreferenceModel = result.responseObject;
        let answerss = this.PreferenceModel.preferenceDetails.answerInputs.split(',')
        this.image = this.PreferenceModel.preferenceDetails.imagePath ?? './../../../assets/images/no-img.png';
        this.editPreferenceForm.controls["brand"].setValue(this.PreferenceModel.preferenceDetails.brand);
        this.editPreferenceForm.patchValue({
          ...result.responseObject,
          answers: answerss
          // vehicletype: this.PreferenceModel.specialToolDetails.vehicleType
        })
      }
    })
    this.spinner.hide();
  }

  editPreferences() {
    this.spinner.show();
    let currentUser = this.userService.currentUserValue.id;
    this.answers = this.editPreferenceForm.get('answers').value.toString()
    const viewModel = {
      ...this.editPreferenceForm.value,
      image: this.editedPreference.image,
      mimeType: this.editedPreference.mimeType,
      imageBinaryData: this.editedPreference.imageBinaryData,
      answerInputs: this.answers,
      updatedBy: currentUser,
      brandId: this.brandList.find(x => x.brandName === this.editPreferenceForm.get('brand').value).id,
      id: this.PreferenceModel.preferenceDetails.id
    }
    const isValidFormat = this.imageService.validateImageFormat(this.editedPreference.mimeType);
    if (isValidFormat) {
      this.preferenceService.addEditPreference(viewModel).then(res => {
        if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
          let successmsg = this.translate.instant("lblPreferencesUpdated");
          this.toastr.success(successmsg);
          this.spinner.hide();
          this.activeModal.close({ success: true });
        }
        else if (res.responseObject === false) {
          this.spinner.hide();
          let errormsg = this.translate.instant("lblPreferenceExist");
          this.toastr.warning(errormsg);
        }
      });
    }
    else {
      let imageErr = this.translate.instant("lblImageFormatError");
      this.toastr.error(imageErr)
    }
    this.spinner.hide();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  OnClose() {
    this.activeModal.close({success:false})
  }
}
